import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import seeqLogoWhite2026 from 'resources/img/seeq_logo_white_2026_sm_padding.png';
import { SeeqLogo2026 } from '@/core/SeeqLogoWhite.atom';
import { WrapperWithLink } from '@/core/WrapperWithLink.atom';
import { getWorkbooksLink } from '@/main/routing.utilities';
import { resetWorkbookType, setWorkbookDisplayMode } from '@/workbook/workbook.actions';
import { WORKBOOK_DISPLAY } from '@/workbook/workbook.constants';

interface HeaderLogoProps {
  disableLink?: boolean;
}

export const HeaderLogo = ({ disableLink = false }: HeaderLogoProps) => {
  const navigate = useNavigate();

  const gotoHomeScreen = () => {
    resetWorkbookType();
    navigate(getWorkbooksLink());
    setWorkbookDisplayMode(WORKBOOK_DISPLAY.EDIT);
  };

  return (
    <div className="headerLogo tw:w-sq-80" data-testid="headerLogo">
      <WrapperWithLink link={getWorkbooksLink()}>
        <div className={clsx('navbar-nav tw:pr-0 tw:pl-0', disableLink ? 'tw:cursor-default' : 'cursorPointer')}>
          <SeeqLogo2026
            className="tw:mt-1 tw:mr-sq-15 tw:mb-sq-5 tw:ml-sq-5"
            onClick={disableLink ? undefined : gotoHomeScreen}
            src={seeqLogoWhite2026}
            width={80}
          />
        </div>
      </WrapperWithLink>
    </div>
  );
};
